
import React, { useMemo } from 'react';
import { AppState, Location } from '../types';
import { LOCATIONS, DEPARTMENTS } from '../constants';

interface HeaderProps {
  state: AppState;
  setState: React.Dispatch<React.SetStateAction<AppState>>;
  location: Location;
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ state, onMenuClick }) => {
  const currentLocation = useMemo(() => 
    LOCATIONS.find(l => l.id === state.currentLocation) || LOCATIONS[0],
    [state.currentLocation]
  );

  return (
    <header className="bg-white border-b-2 border-black/5 px-4 md:px-10 py-4 md:py-6 flex flex-col md:flex-row items-center justify-between sticky top-0 z-40 gap-4">
      <div className="flex items-center justify-between w-full md:w-auto md:space-x-12">
        <div className="flex items-center">
          <button 
            onClick={onMenuClick}
            className="lg:hidden p-2 -ml-2 mr-4 text-black hover:bg-gray-100 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          
          <div className="flex flex-col">
            <span className="inline-block bg-[#CCE1FF] px-1 self-start text-[8px] md:text-[10px] font-black text-gray-500 uppercase tracking-[0.2em] mb-1">
              Operational Site
            </span>
            <h2 className="font-bold text-black text-lg md:text-2xl ymca-brand-font tracking-wider uppercase leading-none">
              {currentLocation.name}
            </h2>
          </div>
        </div>

        <div className="hidden md:block h-10 w-[1px] bg-gray-200"></div>

        <div className="flex flex-col ml-4 md:ml-0">
          <span className="inline-block bg-[#CCE1FF] px-1 self-start text-[8px] md:text-[10px] font-black text-gray-500 uppercase tracking-[0.2em] mb-1">
            Division
          </span>
          <h2 className="font-bold text-black text-lg md:text-2xl ymca-brand-font tracking-wider uppercase leading-none">
            {state.currentDepartment}
          </h2>
        </div>
      </div>

      <div className="flex items-center space-x-4 w-full md:w-auto">
        <div className="relative flex-1 md:flex-initial">
          <input 
            type="text" 
            placeholder="Search UnityForce..." 
            className="w-full md:w-64 lg:w-80 pl-4 pr-10 py-2.5 md:py-3 bg-gray-50 border border-gray-200 focus:border-black focus:bg-white transition-all text-sm font-medium rounded-none"
          />
          <svg className="w-4 h-4 text-gray-400 absolute right-3 top-3 md:top-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
        <button className="p-2.5 md:p-3 border border-black hover:bg-black hover:text-white transition-all hidden md:block">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth={1.5} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;
